import { render, staticRenderFns } from "./healthy_management.vue?vue&type=template&id=110a5f47&scoped=true&"
import script from "./healthy_management.vue?vue&type=script&lang=js&"
export * from "./healthy_management.vue?vue&type=script&lang=js&"
import style0 from "./healthy_management.vue?vue&type=style&index=0&id=110a5f47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a5f47",
  null
  
)

export default component.exports